export const HIGHLIGHT_CLASS_NAME = 'hll';
